import { Box, Container, Stack } from "@mui/material";
import React from "react";

import { styles } from "./style";

const SectionLayout = ({ children, id, style }) => {
  return (
    <Box
      component="div"
      id={id}
      sx={{
        ...styles.sectionContainer,
        ...style,
        pb: style?.pb || { xs: 24, md: 36 },
        pt: style?.pt || { xs: 24, md: 36 },
      }}
    >
      <Container maxWidth="xl">{children}</Container>
    </Box>
  );
};

export default SectionLayout;
